<template>
  <div id="incidents">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer/>
            <v-btn depressed
              color="primary"
              @click="filter = true">
              {{$t('reports.filter')}}
              <v-icon small class="ml-2">
                fas fa-align-center
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-overlay absolute opacity="0" :value="loadTable"/>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :footer-props="{ 'items-per-page-options': [50, 70, 100] }"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="getIncidents"
              @update:items-per-page="getIncidents"
              @update:sort-by="getIncidents"
              @update:sort-desc="getIncidents"
              :items="incidents">
              <template v-slot:item="props">
                <tr>
                  <!-- No. Inspection -->
                  <td align="left">
                    {{props.item.inspection.consecutive_number}}
                  </td>
                  <!-- VIN -->
                  <td align="left" v-if="props.item.inspection && props.item.inspection.truck !== null">
                    {{props.item.inspection.truck.vin_number ? props.item.inspection.truck.vin_number : '--'}}
                  </td>
                  <td align="left" v-if="props.item.inspection.truck === null && props.item.inspection && props.item.inspection.container !== null">
                    {{props.item.inspection.container.vin_number ? props.item.inspection.container.vin_number : '--'}}
                  </td>
                  <!-- Placas -->
                  <td align="left" v-if="props.item.inspection && props.item.inspection.truck !== null">
                    {{props.item.inspection.truck.plates.length > 0 && props.item.inspection.truck.plates[0].plate_number ?
                      props.item.inspection.truck.plates[0].plate_number : $t('units.noPlates')
                    }}
                  </td>
                  <td align="left" v-if="props.item.inspection && props.item.inspection.truck === null && props.item.inspection.container !== null">
                    {{props.item.inspection.container.plates.length > 0 && props.item.inspection.container.plates[0].plate_number ?
                      props.item.inspection.container.plates[0].plate_number : $t('units.noPlates')
                    }}
                  </td>
                  <!-- No. Economico -->
                  <td align="left" v-if="props.item.inspection && props.item.inspection.truck !== null">
                    {{props.item.inspection.truck.unit_number ? props.item.inspection.truck.unit_number : '--'}}
                  </td>
                  <td align="left" v-if="props.item.inspection.truck === null && props.item.inspection.container !== null">
                    {{props.item.inspection && props.item.inspection.container && props.item.inspection.container.unit_number ? props.item.inspection.container.unit_number : '--'}}
                  </td>
                  <!-- Tipo de unidad -->
                  <td align="left" v-if="props.item.inspection.truck !== null">
                    {{props.item.inspection && props.item.inspection.truck && props.item.inspection.truck.unit_types && props.item.inspection.truck.unit_types.alias ?
                      props.item.inspection.truck.unit_types.alias : '--'
                    }}
                  </td>
                  <td align="left" v-if="props.item.inspection.truck === null && props.item.inspection.container !== null">
                    {{props.item.inspection && props.item.inspection.container && props.item.inspection.container.unit_types && props.item.inspection.container.unit_types.name ?
                      props.item.inspection.container.unit_types.name : '--'
                    }}
                  </td>
                  <!-- Patio -->
                  <td align="left">
                    {{props.item.inspection && props.item.inspection.site && props.item.inspection.site.name ? props.item.inspection.site.name : '--'}}
                  </td>
                  <!-- Propiedad -->
                  <td align="left" v-if="props.item.inspection && props.item.inspection.truck !== null">
                    {{props.item.inspection && props.item.inspection.truck && props.item.inspection.truck.owner_name ? props.item.inspection.truck.owner_name : '--'}}
                  </td>
                  <td align="left" v-if="props.item.inspection && props.item.inspection.truck === null && props.item.inspection.container !== null">
                    {{props.item.inspection.container.owner_name ? props.item.inspection.container.owner_name : '--'}}
                  </td>
                  <!-- Estado -->
                  <td align="left" v-if="props.item.inspection && props.item.inspection.truck !== null">
                    {{ props.item.inspection.truck.status ? props.item.inspection.truck.status : '--' }}
                  </td>
                  <td align="left" v-if="props.item.inspection && props.item.inspection.truck === null && props.item.inspection.container !== null">
                    {{ props.item.inspection.container.status ? props.item.inspection.container.status : '--' }}
                  </td>
                  <!-- Fecha de reparacion -->
                  <td align="left">
                    {{props.item.repair_at ? props.item.repair_at : '--'}}
                  </td>
                  <!-- Dias inactivo -->
                  <td align="left">{{props.item.inspection && props.item.inspection.out_service_days ? props.item.inspection.out_service_days : '--'}}</td>
                  <td align="center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon 
                          small v-on="on"
                          @click="openDamage(props.item.id)">
                          far fa-eye
                        </v-icon>
                      </template>
                      <span>{{$t('general.seeDetail')}}</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="ml-3"
                          @click="statusModal = true"
                          small v-on="on">
                          fa fa-history
                        </v-icon>
                      </template>
                      <span>{{$t('general.changeStatus')}}</span>
                    </v-tooltip> -->
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Modal cambiar estado -->
    <v-dialog
      v-model="statusModal"
      max-width="400px">
      <v-card>
        <v-card-title class="d-flex justify-space-between grey lighten-3">
          {{$t('general.changeStatus')}}
          <v-btn icon @click="statusModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-5"/>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                :label="$t('general.selectStatus')"
                :items="statusList"
                item-value="value"
                item-text="text"
                outlined
                dense
                hide-details
                v-model="status">
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn depressed outlined color="primary" @click="statusModal = false">{{$t('general.cancel')}}</v-btn>
          <v-btn depressed
            color="primary">
            {{$t('general.search')}}
          </v-btn>
        </v-card-actions>
      </v-card>  
    </v-dialog>
    <!-- Modal filtrado -->
    <v-dialog
      v-model="filter"
      max-width="500px">
      <v-card>
        <v-card-title class="d-flex justify-space-between grey lighten-3">
          {{$t('reports.filter')}}
          <v-btn icon @click="filter = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-5"/>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                hide-details
                v-model="unit.vin"
                label="VIN"
                class="mb-4"/>
              <v-text-field
                outlined
                dense
                hide-details
                v-model="unit.plaque"
                :label="$t('monitoring.plaque')"
                class="mb-4"/>
              <v-text-field
                outlined
                dense
                hide-details
                v-model="unit.number_economic"
                :label="$t('monitoring.numberEconomic')"
                class="mb-4"/>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn depressed outlined color="primary" @click="filter = false">{{$t('general.cancel')}}</v-btn>
          <v-btn depressed
            @click="getFilter"
            color="primary">
            {{$t('general.search')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'Incidents',
  data () {
    return {
      status: '',
      statusModal: false,
      filter: false,
      loadTable: false,
      incidents: [],
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      unit: {
        vin: null,
        plaque: null,
        number_economic: null,
        date_start: null,
        date_end: null
      }
    }
  },
  computed: {
    statusList () {
      return [
        {
          value: 'IN_PROGRESS',
          text: this.$t('general.inProgress')
        },
        {
          value: 'SUCCESS',
          text: this.$t('general.finishStatus')
        }
      ]
    },
    headers () {
      return [
        {
          text: this.$t('general.noInspection'),
          value: 'no_inspection',
          align: 'left',
          sortable: true
        },
        {
          text: 'VIN',
          value: 'vin_number',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.plates'),
          value: 'plates',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.unitNumber'),
          value: 'unit_number',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.unitType'),
          value: 'unit_types',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.site'),
          value: 'site',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('monitoring.property'),
          value: 'owner_name',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('address.state'),
          value: 'status',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.repairDate'),
          value: 'repair_at',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('monitoring.inactiveDays'),
          value: 'out_service_days',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getIncidents()
  },
  methods: {
    /** Metodo que permite ir a la vista de reporte de daños */
    openDamage (id) {
      this.$router.push('/detail-incident/' + id)
    },
    getIncidents () {
      this.loadTable = true
      this.$store.dispatch('incidents/getAllIncidents', {
        event: {
          context: this,
          vin: this.unit.vin,
          plate: this.unit.plaque,
          unit_number: this.unit.number_economic,
          date_start: this.unit.date_start,
          date_end: this.unit.date_end,
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sortKey: this.options.sortBy ? this.options.sortBy[0] : 'id',
          ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc'
        }
      })
    },
    getFilter () {
      this.getIncidents()
      this.unit.vin = ''
      this.unit.plaque = ''
      this.unit.number_economic = ''
      this.filter = false
    }
  }
}
</script>
<style>